import {
    createContext,
    useContext,
    useState,
    useMemo,
    useCallback,
    memo,
    ReactNode,
  } from "react";
  
  const ZoomContext = createContext<any>({
    workbenchZoomLevel: 1,
    zoomValue: 100,
    getWorkbenchZoomLevel: () => {},
    getZoomValue: () => {},
  });
  export const useZoomContext = () => useContext(ZoomContext);
  
  const ZoomProvider = ({ children }: { children: ReactNode }) => {
    const [workbenchZoomLevel, setWorkbenchZoomLevel] = useState(1);
    const [zoomValue, setZoomValue] = useState(100);
  
    const getWorkbenchZoomLevel = useCallback(
      (level: any) => setWorkbenchZoomLevel(level),
      []
    );
    const getZoomValue = useCallback((value: any) => setZoomValue(value), []);
  
    const contextValue = useMemo(
      () => ({
        workbenchZoomLevel,
        zoomValue,
        getWorkbenchZoomLevel,
        getZoomValue,
      }),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [workbenchZoomLevel, zoomValue]
    );
  
    return (
      <ZoomContext.Provider value={contextValue}>{children}</ZoomContext.Provider>
    );
  };
  
  export default memo(ZoomProvider);
  